// extracted by mini-css-extract-plugin
export default {"item":"SocialMedia_item__F+QOE"};